const quiz = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "quiz",
    items: [
      { id: "q1", question: "What day comes after Monday? ", answers: ["Tuesday"], image: null },
      { id: "q2", question: "What day comes after Tuesday? ", answers: ["Wednesday"], image: null },
      { id: "q3", question: "What day comes after Wednesday? ", answers: ["Thursday"], image: null },
      { id: "q4", question: "What day comes after Thursday? ", answers: ["Friday"], image: null },
      { id: "q5", question: "What day comes after Friday? ", answers: ["Saturday"], image: null },
      { id: "q6", question: "What day comes after Saturday? ", answers: ["Sunday"], image: null },
      { id: "q7", question: "What day comes after Sunday? ", answers: ["Monday"], image: null },
      { id: "q8", question: "What is the first day of the week? ", answers: ["Monday"], image: null },
      { id: "q9", question: "What is the last day of the week? ", answers: ["Sunday"], image: null },
      { id: "q10", question: "How many days are there in a week? ", answers: ["7", "seven"], image: null },
    ],
  },
  botId: "nualang.quiz.0.0.1",
  botName: "quiz",
  description: "quiz_desc",
  difficulty: "ALL",
  learnLang: "english",
  name: "Joanna",
  botAvatar:
    "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwMi5wbmcifQ==",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-question-circle?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# Welcome to the quiz
Hosted by Joanna.

Do you know the days of the week?

Say "Hello" to Joanna to begin.`,
  voice: "Joanna",
  versionQuestion: "How many questions would you like in this template?",
};

export default quiz;
